export default __webpack_public_path__ + "static/radar-icon-f7ebfc49dafbf3856ff30ae54fb78078.png";